import React from 'react';
import type { BusinessListingPreview } from '../types';
import AppListingPreview from './AppListingPreview';
import Phone15Frame from './Phone15Frame';

export type BusinessListingPreviewProps = {
  preview: BusinessListingPreview;
  /** Custom in-app mockup — rendered inside the phone frame. */
  renderVisual?: (preview: BusinessListingPreview) => React.ReactNode;
};

const BusinessListingPreviewPanel: React.FC<BusinessListingPreviewProps> = ({
  preview,
  renderVisual,
}) => (
  <aside className="flex flex-col" aria-label="Vista previa del negocio en la app">
    <h2 className="mb-5 font-instrument text-2xl italic tracking-[-0.01em] text-[#2a0f2a]">
      Vista previa
    </h2>
    <Phone15Frame>{renderVisual?.(preview) ?? <AppListingPreview preview={preview} />}</Phone15Frame>
  </aside>
);

export default BusinessListingPreviewPanel;
